(function profileScript($, Drupal) {
  Drupal.behaviors.profile = {
    attach(context) {
      $('.profile__content', context).each(function profileInfo() {
        const $this = $(this);
        const $target = $this.children('.profile__text');
        $target.attr('hidden', true);
        $target.before(`
          <button aria-expanded="false" class="js-toggle__profile-info">
          <svg xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24"><path fill="#0D1832" fill-rule="nonzero" d="M23.1 11.1H13V1a.9.9 0 1 0-1.8 0V11H1a.9.9 0 1 0 0 1.8H11V23a.9.9 0 1 0 1.8 0V13H23a.9.9 0 1 0 0-1.8z"/></svg>
          <span class="visually-hidden">Bio</span>
          </button>`);
        const $btn = $this.children('button');

        $btn.on('click', function toggleVisibility() {
          let expanded = $btn.attr('aria-expanded') === 'true';

          $btn.attr('aria-expanded', !expanded);
          $target.attr('hidden', expanded);
          $this.toggleClass('is-expanded');
        });
      });
    }
  };
}(jQuery, Drupal));
